/**
 * classifyCo2.js : position d'une valeur de CO2 (ppm) par rapport à la valeur
 * max recommandée (CO2_THRESHOLDS.referenceMax, D253).
 *
 * Une seule référence, non alertante : ni les trois paliers de classifyPm, ni
 * la plage normale de classifyEnv. La valeur pile sur la référence est 'ok',
 * comme une valeur PM pile sur un seuil reste au palier inférieur. Valeur
 * absente → 'not_measured', jamais 'ok' (D190). La référence n'est lue que
 * dans pmThresholds.json : aucun littéral ici.
 */
import { CO2_THRESHOLDS } from './pmThresholds';

export const CO2_LEVELS = Object.freeze({
  OK: 'ok',
  ABOVE_REFERENCE: 'above_reference',
  NOT_MEASURED: 'not_measured',
});

/**
 * @param {number|null} value  CO2 en ppm, null si non mesuré.
 * @returns {'ok'|'above_reference'|'not_measured'}
 */
export function classifyCo2(value) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return CO2_LEVELS.NOT_MEASURED;
  return value <= CO2_THRESHOLDS.referenceMax ? CO2_LEVELS.OK : CO2_LEVELS.ABOVE_REFERENCE;
}
